// Module
var code = "<div class=\"timeline-image filename-only\"> <div ng-show=\"!$ctrl.filename\" class=\"fake-image\"> <span></span><span>file (0K)</span> </div> <div ng-show=\"$ctrl.filename\" class=\"truncate fileWrapper\"> <a href=\"#\" ng-click=\"$ctrl.downloadClick()\" title=\"{{::$ctrl.filename}}\"> {{::$ctrl.filename}}</a> </div> </div> ";
// Exports
export default code;